// Counted, not per-dialog: two dialogs can overlap, and the one that closes
// second must not restore the scrollbar while the first is still open.
let openDialogs = 0;
let overflowBeforeLock = '';

export default () => {
  let holdsLock = false;

  function lock(): void {
    if (!import.meta.client || holdsLock) return;
    holdsLock = true;
    if (openDialogs++ === 0) {
      overflowBeforeLock = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
  }

  function unlock(): void {
    if (!import.meta.client || !holdsLock) return;
    holdsLock = false;
    if (--openDialogs === 0) {
      document.body.style.overflow = overflowBeforeLock;
    }
  }

  onUnmounted(unlock);

  return { lock, unlock };
};
